import React from "react";
import { Link } from "react-router-dom";

function CommonStyles() {
  return (
    <style jsx>{`
      .container {
        max-width: 960px;
        margin: 0 auto;
        padding: 20px;
        line-height: 1.5;
        font-size: 15px;
        font-family: "FreeSans", sans-serif;
        color: #222;
      }

      header h1 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 700;
      }

      .text p {
        margin-bottom: 1em;
        font-size: 0.95rem;
        color: #333;
      }

      h2 {
        margin-top: 2.5em;
        font-size: 1.8rem;
        font-weight: 600;
      }

      .lang-switch {
        position: absolute;
        top: 20px;
        right: 20px;
      }

      .lang-switch button {
        background: #000;
        color: #fff;
        padding: 5px 12px;
        border-radius: 6px;
        font-size: 0.8rem;
        border: none;
        cursor: pointer;
        transition: opacity 0.25s ease;
      }

      .lang-switch button:hover {
        opacity: 0.8;
      }

          .back-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
        }

        .back-button button {
          background: #000;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 0.9rem;
          border: none;
          cursor: pointer;
          transition: opacity 0.25s ease;
        }

        .back-button button:hover {
          opacity: 0.8;
        }

      @media (max-width: 600px) {
        .container {
          padding: 16px;
          font-size: 14px;
        }

        .text p {
          font-size: 0.8rem;
        }

        header h1 {
          font-size: 1.8rem;
        }

        h2 {
          font-size: 1.4rem;
        }
      }
    `}</style>
  );
}

export default function ArchivDe() {
  return (
    <article className="container">
      <div className="lang-switch">
        <Link to="/ArchivEn">
          <button>EN</button>
        </Link>
      </div>

      <header>
        <h1>Zeitlinien</h1>
      </header>

      <section className="text">
        <p><strong>Gedächtnisarchiv – Kunst als Speicher der Zeit</strong></p>
        <p>Zeitlinien ab 2025</p>
        <p>von Billi Thanner</p>

        <p>Ich arbeite mit Linien.</p>
        <p>Doch eigentlich arbeite ich mit Erinnerung.</p>

        <p>
          Meine Ideen schöpfe ich aus der Natur,
          aus Steinen, Licht, Wind und Wasser.
          Und zugleich aus dem Himmel.
        </p>

        <p>
          Sie entstehen aus dem Gedanken,
          dass die Welt nicht getrennt, sondern verbunden ist.
        </p>

        <p>
          Die Farben meiner Arbeiten kommen aus der Erde:
          Stein, Staub, Metall, Licht.
          Ihre Leuchtkraft ist eine Erinnerung.
        </p>

        <p>
          Jede Linie, die entsteht, trägt einen Moment,
          einen Gedanken, einen Zustand, ein inneres Bild.
          Die Linien verbinden das, was ist, mit dem, was war und noch kommt.
          Sie schaffen ein Archiv,
          kein Archiv aus Fakten, sondern aus Gefühl.
        </p>

        <p>
          Und all das entsteht aus dem Versuch,
          den gegenwärtigen Moment zu begreifen,
          jenen kurzen Augenblick, der still wird.
          Wir finden Licht und Frequenzen in den Werken,
          weil ich diese unaufhaltbaren Momente unseres Daseins
          in meiner Kunst festhalten möchte.
        </p>

        <p>
          Ich glaube daran, dass Zeit nicht vergeht,
          sondern sich wandelt.
          Sie speichert sich in Licht, Farbe und Material.
        </p>

        <p>
          Meine Zeitlinien sind ein Gedächtnisarchiv,
          und zugleich ein Ruf in die Zukunft.
        </p>

        <p>
          Wenn ich arbeite, höre ich zu.
          Ich suche nicht nach Form,
          sondern lausche dem, was da ist.
          Und manchmal zeichnet sich eine Linie ab,
          klar, ruhig, notwendig.
        </p>

        <p>
          Diese Serie ist meine Art, mit der Welt zu sprechen,
          mit dem Raum, mit der Zeit, mit Licht,
          mit allem, was war und bleibt.
        </p>

        <p>
          Wenn wir vor einem Werk still werden,
          beginnt das Archiv zu sprechen,
          ohne Worte, nur als gefühlte Erinnerung.
          Es braucht keine Sprache,
          nur unsere Blicke.
        </p>

        <p>Und wer will, kann hinsehen.</p>

        <p><strong>Billi Thanner</strong></p>
      </section>

      <div className="back-button">
        <Link to="/Zeitlinien">
          <button>zurück</button>
        </Link>
      </div>

      <CommonStyles />
    </article>
  );
}